import { Component, Inject, OnInit, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogoutService } from '../../components/auth/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-organisation-modal',
  templateUrl: './organisation-modal.component.html',
  styleUrls: ['./organisation-modal.component.scss']
})
export class OrganisationModalComponent implements OnInit {
  organizationData: any = [];
  selectedOrgId: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<OrganisationModalComponent>,
    private _logoutService: LogoutService, private snackbar: MatSnackBar) { }

  ngOnInit(): void {
    // console.log('data----',this.data);
    this.getOrganizationData();
  }

  async getOrganizationData() {
    this.organizationData = await this._logoutService.getOrganizationData(this.data);
    if (this.organizationData.length > 0) {
      this.selectedOrgId = this.organizationData[0].id;
    }
  }

  ngOnChanges(changes: any): void {
    if (changes.organizationData && changes.organizationData.currentValue.length > 0) {
      this.selectedOrgId = this.organizationData[0].id;
    }
  }


  onClickOption(id: string) {
    // console.log('id----',id);
    // this.dialogRef.close(id);
    this.selectedOrgId = id
  }

  login() {
    if (this.selectedOrgId) {
      this.dialogRef.close(this.selectedOrgId);
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

}
